// extracted by mini-css-extract-plugin
export default {"desc":"styles-scoped__desc--LEeSF","btnSaveContainer":"styles-scoped__btnSaveContainer--iYa6s","btnSave":"styles-scoped__btnSave--MvMo7"};